// Strings only the web client needs (no Apple/Android counterpart). Same rule as the generated
// tables: every key in BOTH languages. Keys are prefixed `web.` so they never collide with a key
// the native tables add later.
import { strings as destinations } from './web-destinations';
import { strings as search } from './web-search';
import { strings as channelPanel } from './web-channelPanel';
import { strings as people } from './web-people';

const base: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.otherTab.title': 'Satori Chat está abierto en otra pestaña',
    'web.otherTab.body': 'Solo una pestaña puede usar el chat a la vez, para que tus mensajes y avisos no se dupliquen.',
    'web.otherTab.useHere': 'Usar aquí',
    'web.storage.memoryOnly': 'Este navegador no permite guardar el chat en el equipo; se cargará de nuevo al recargar la página.',
    'web.boot.loading': 'Abriendo Satori Chat…',
    'web.menu.appearance': 'Apariencia',
    'web.theme.system': 'Igual que el sistema',
    'web.theme.light': 'Claro',
    'web.theme.dark': 'Oscuro',
    'web.login.lede': 'Entra con tu cuenta de la empresa.',
    'web.nav.forward': 'Adelante',
    'web.nav.backToList': 'Volver a la lista',
    'web.nav.threads': 'Hilos',
    'web.nav.drafts': 'Borradores',
    'web.nav.searchMessages': 'Buscar «%@» en los mensajes',
    'web.nav.newMessage': 'Nuevo mensaje',
    'web.nav.createChannel': 'Crear un canal',
    'web.nav.info': 'Información del canal',
    'web.nav.searchHere': 'Buscar en esta conversación',
    'web.nav.backToRecents': 'Ir a los mensajes recientes',
    'web.msg.more': 'Más acciones',
    'web.msg.editHint': 'Enter para guardar · Esc para cancelar',
    'web.msg.copied': 'Copiado',
    'web.msg.linkCopied': 'Enlace copiado',
    'web.msg.markedUnread': 'Marcado como no leído',
  },
  en: {
    'web.otherTab.title': 'Satori Chat is open in another tab',
    'web.otherTab.body': 'Only one tab can use the chat at a time, so your messages and notifications are never doubled.',
    'web.otherTab.useHere': 'Use here',
    'web.storage.memoryOnly': 'This browser does not allow saving the chat on this computer; it will load again after a reload.',
    'web.boot.loading': 'Opening Satori Chat…',
    'web.menu.appearance': 'Appearance',
    'web.theme.system': 'Same as the system',
    'web.theme.light': 'Light',
    'web.theme.dark': 'Dark',
    'web.login.lede': 'Sign in with your company account.',
    'web.nav.forward': 'Forward',
    'web.nav.backToList': 'Back to the list',
    'web.nav.threads': 'Threads',
    'web.nav.drafts': 'Drafts',
    'web.nav.searchMessages': 'Search messages for “%@”',
    'web.nav.newMessage': 'New message',
    'web.nav.createChannel': 'Create a channel',
    'web.nav.info': 'Channel info',
    'web.nav.searchHere': 'Search this conversation',
    'web.nav.backToRecents': 'Go to recent messages',
    'web.msg.more': 'More actions',
    'web.msg.editHint': 'Enter to save · Esc to cancel',
    'web.msg.copied': 'Copied',
    'web.msg.linkCopied': 'Link copied',
    'web.msg.markedUnread': 'Marked as unread',
  },
};

const parts = [destinations, search, channelPanel, people];
export const webStrings = {
  es: Object.assign({}, base.es, ...parts.map((p) => p.es)) as Record<string, string>,
  en: Object.assign({}, base.en, ...parts.map((p) => p.en)) as Record<string, string>,
};
